import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import MultiTable from "../../../Common/MUITable";
import {
  DEFAULT_HOOK_LOADER_INNER_FILTERS,
} from "./staticReportData";
import HookLoaderInnerFilter from "./HookLoaderInnerFilter";
import DelhiReportExport from "./DelhiReportExport";
import {
  HookLoaderVehicleInnerReport,
  GetAllCircles,
  GetTransferStationsList,
} from "./ReportApi";


const tableColumns = [
  {
    label: "Ward",
    field: "wardName",
    width: "90px",
  },
  {
    label: "HL Vehicle No",
    field: "vehicleNo",
    width: "130px",
  },
  {
    label: "FCTS",
    field: "fctsName",
    width: "160px",
  },
  {
    label: "Reported at Dumping Location",
    field: "dumpsiteName",
    width: "180px",
  },
  {
    label: "Date",
    field: "reportedDate",
    width: "110px",
  },
  {
    label: "Time",
    field: "reportedTime",
    width: "80px",
  },
  {
    label: "Tonnage",
    children: [
      {
        label: "Gross Weighment",
        field: "grossWeighment",
        width: "110px",
      },
      {
        label: "Tare Weighment",
        field: "tareWeighment",
        width: "110px",
      },
      {
        label: "Net Weighment",
        field: "netWeighment",
        width: "110px",
      },
    ],
  },
  {
    label: "Pic of wb slip",
    field: "picOfWbSlip",
    width: "110px",
    render: (row) =>
      row.picOfWbSlip ? (
        <img src={row.picOfWbSlip} alt="WB Slip" />
      ) : (
        "N/A"
      ),
  },
];

const exportColumns = [
  { label: "Ward", field: "wardName" },
  { label: "HL Vehicle No", field: "vehicleNo" },
  { label: "FCTS", field: "fctsName" },
  { label: "Reported at Dumping Location", field: "dumpsiteName" },
  { label: "Date", field: "reportedDate" },
  { label: "Time", field: "reportedTime" },
  {
    label: "Tonnage",
    children: [
      { label: "Gross Weighment", field: "grossWeighment" },
      { label: "Tare Weighment", field: "tareWeighment" },
      { label: "Net Weighment", field: "netWeighment" },
    ],
  },
];

// Normalizes a vehicle number for comparison: removes ALL whitespace and
// converts to uppercase, so "87987", " 87987 ", "87987\n" etc. all match.
const normalizeVehicleNo = (value) =>
  String(value ?? "")
    .replace(/\s+/g, "")
    .toUpperCase();

const HookLoaderInnerReport = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const parentRow = location.state?.parentRow;
  const parentRows = location.state?.parentRows || [];
  const showAllTrips = Boolean(location.state?.showAllTrips);
  const lockedVehicleNo = showAllTrips ? "" : parentRow?.vehicleNo || "";
  console.log("🔥 INNER SHOW ALL:", showAllTrips);
  console.log("🔥 INNER SELECTED VEHICLE:", parentRow?.vehicleNo);

  const [filters, setFilters] = useState({
    ...DEFAULT_HOOK_LOADER_INNER_FILTERS,
    vehicleNo: lockedVehicleNo,
    wardId: showAllTrips ? "" : parentRow?.wardId || "",
  });
  const [appliedFilters, setAppliedFilters] = useState({
    ...DEFAULT_HOOK_LOADER_INNER_FILTERS,
    vehicleNo: lockedVehicleNo,
    wardId: showAllTrips ? "" : parentRow?.wardId || "",
  });
  const [reportData, setReportData] = useState([]);
  const [loadingReport, setLoadingReport] = useState(false);
const [wardOptions, setWardOptions] = useState([]);
const [fctsOptions, setFctsOptions] = useState([]);
  useEffect(() => {
    loadInnerReport();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [appliedFilters, lockedVehicleNo]);
useEffect(() => {
  const loadDropdownData = async () => {
    try {
      const circlesResponse = await GetAllCircles();
      console.log("🔥 CIRCLES RESPONSE:", circlesResponse);
      const circles = circlesResponse?.data?.data || [];
      const mappedWards = circles.map((c) => ({
        wardId: c.CircleId ?? c.circleId ?? c.WardId,
        wardName: c.CircleName ?? c.circleName ?? c.WardName,
      }));
      setWardOptions(mappedWards);
    } catch (error) {
      console.error("❌ CIRCLES API ERROR:", error);
      setWardOptions([]);
    }

    try {
      const fctsResponse = await GetTransferStationsList();
      console.log("🔥 FCTS RESPONSE:", fctsResponse);
      const stations = fctsResponse?.data?.data || [];
      const mappedFcts = [
        { value: "", label: "Select FCTS" },
        ...stations.map((s) => ({
          value: s.TransferStationId ?? s.transferStationId ?? s.Id,
          label: s.TransferStationName ?? s.transferStationName ?? s.Name,
        })),
      ];
      setFctsOptions(mappedFcts);
    } catch (error) {
      console.error("❌ FCTS API ERROR:", error);
      setFctsOptions([]);
    }
  };

  loadDropdownData();
}, []);
  const loadInnerReport = async () => {
    setLoadingReport(true);

    try {
                        const response = await HookLoaderVehicleInnerReport({
        vehicleNumber:
          lockedVehicleNo || appliedFilters.vehicleNo || null,

        wardId:
         appliedFilters.wardId || null,

        fctsId:
          appliedFilters.fctsId || null,

        dumpsiteId:
          appliedFilters.dumpsiteId || null,

        fromDateTime: appliedFilters.fromDateTime || null,
        toDateTime: appliedFilters.toDateTime || null,
      });

      console.log("🔥 INNER REPORT RESPONSE:", response);

      const data = response?.data?.data || [];

      console.log("🔥 INNER REPORT DATA:", data);
      console.log("🔥 lockedVehicleNo VALUE:", lockedVehicleNo, "| normalized:", normalizeVehicleNo(lockedVehicleNo));
      console.log("🔥 showAllTrips VALUE:", showAllTrips);
      console.log(
        "🔥 Row vehicle values:",
        data.map((r) => ({
          raw: r.HLVehicleNo,
          normalized: normalizeVehicleNo(r.HLVehicleNo),
        }))
      );

      
      const targetVehicleNo = normalizeVehicleNo(lockedVehicleNo);

      const filteredData =
        showAllTrips || !targetVehicleNo
          ? data
          : data.filter(
              (row) => normalizeVehicleNo(row.HLVehicleNo) === targetVehicleNo
            );

   

      const formattedData = filteredData.map((row) => {
        const date = row.ReportedDateTime
          ? new Date(row.ReportedDateTime)
          : null;

        return {
          wardName: row.WardName || "",

          vehicleNo: row.HLVehicleNo || "",

          fctsName: row.FCTS || "",

          dumpsiteName: row.DumpingLocation || "",

          reportedDate: date
            ? date.toLocaleDateString()
            : "",

          reportedTime: date
            ? date.toLocaleTimeString()
            : "",

          grossWeighment: row.GrossWeighment ?? "",

          tareWeighment: row.TareWeighment ?? "",

          netWeighment: row.NetWeighment ?? "",

          picOfWbSlip: row.WbSlipImage || "",
        };
      });

     

      setReportData(formattedData);

    } catch (error) {
      console.error(
        "INNER REPORT API ERROR:",
        error
      );

      setReportData([]);

    } finally {
      setLoadingReport(false);
    }
  };


  const handleSearch = (values) => {
    setAppliedFilters({
      ...values,
      vehicleNo: lockedVehicleNo || values.vehicleNo,
    });
  };

  const handleReset = () => {
    const resetValues = {
      ...DEFAULT_HOOK_LOADER_INNER_FILTERS,
      vehicleNo: lockedVehicleNo,
      wardId: showAllTrips ? "" : parentRow?.wardId || "",
    };
    setFilters(resetValues);
    setAppliedFilters(resetValues);
  };

  return (
    <div className="content text-start">
      <div className="page-content">
        <div className="d-flex flex-column flex-md-row justify-content-between align-items-start gap-3 mt-3 mb-3">
          <div className="me-md-3">
            <h5 className="mb-1 fw-semibold">Hook Loader Inner Report</h5>
            <p className="text-muted mb-0">
              View Hook Loader trip details.
              {showAllTrips
                ? " (All trips)"
                : parentRow?.vehicleNo
                  ? ` (${parentRow.vehicleNo})`
                  : ""}
            </p>
          </div>
          <div className="d-flex flex-wrap gap-2">
            <button
              type="button"
              className="button-container"
              onClick={() => navigate("/hook-loader-report")}
            >
              Back
            </button>
            <DelhiReportExport
              reportData={reportData}
              reportTitle="Hook Loader Inner Report"
              columns={exportColumns}
              fileName="HookLoaderInnerReport"
            />
          </div>
        </div>

        <div className="card shadow mb-3">
          <div className="card-body">
            <HookLoaderInnerFilter
              initialValues={filters}
              wardOptions={wardOptions}
              fctsOptions={fctsOptions}
              lockedVehicleNo={lockedVehicleNo}
              onSearch={(values) => {
                setFilters({
                  ...values,
                  vehicleNo: lockedVehicleNo || values.vehicleNo,
                });
                handleSearch(values);
              }}
              onReset={handleReset}
            />
          </div>
        </div>

        <div className="card shadow">
          <div className="card-body">
            <div className="top-header text-center">
              <span>Hook Loader Inner Report</span>
            </div>
            <div className="table-responsive">
              <MultiTable
                needSRNumber
                columns={tableColumns}
                rows={reportData}
                tableHeight={500}
                rowsPerPageOptions={[10, 25, 50, 100]}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HookLoaderInnerReport;